import vars from '../helpers';

function scrollHandler() {
	const offset = 300;

	if (vars.$window.scrollTop() >= offset) {
		vars.$body.addClass('is-fixed');

		setTimeout(() => {
			vars.$body.addClass('is-fix_animate');
		}, 500);
	} else {
		vars.$body.removeClass('is-fixed');

		setTimeout(() => {
			vars.$body.removeClass('is-fix_animate');
		}, 500);
	}
}

function init() {
	vars.$window.on('scroll.fixed', scrollHandler);
}

function destroy() {
	vars.$window.off('scroll.fixed', scrollHandler);
	vars.$body.removeClass('is-fix_animate is-fixed');
}

export default {
	init,
	destroy,
};
